export default class ServiceSubjectController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/serviceSubject/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/delete', 'post', params, axiosOption, httpOption);
  }

  static startOnlyFlowService (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/startOnly/flowService', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyFlowService (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/startWithBusinessKey/flowService', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskFlowService (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/startAndTakeUserTask/flowService', 'post', params, axiosOption, httpOption);
  }

  static startAndSaveDraftFlowService (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/startAndSaveDraft/flowService', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskFlowService (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/submitUserTask/flowService', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataFlowService (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/viewTaskBusinessData/flowService', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataFlowService (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/viewHistoricTaskBusinessData/flowService', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderFlowService (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceSubject/listWorkOrder/flowService', 'post', params, axiosOption, httpOption);
  }
}
